<!-- eslint-disable prettier/prettier -->
<template>
  <div
    v-if="description || characteristics?.length || equipments?.length"
    class="flex flex-col gap-4 lg:gap-8"
  >
    <div
      v-if="description"
      class="flex flex-col gap-2"
    >
      <h2 class="font-bold text-lg leading-7 text-gray-900">Описание</h2>
      <LazyLotsShowExpandableText
        :text="description.trim()"
        :max-lines="4"
        :font-size="0.875"
        hydrate-on-visible
      >
        <div class="font-medium text-gray-700 text-sm whitespace-pre-line leading-6">
          {{ description.trim() }}
        </div>
      </LazyLotsShowExpandableText>
    </div>
    <div
      v-if="characteristics?.length"
      class="flex flex-col gap-2"
    >
      <h2 class="font-bold text-lg leading-7 text-gray-900">Характеристики</h2>
      <div class="flex flex-col text-sm leading-6">
        <div
          v-for="(characteristic, index) in visibleCharacteristics"
          :key="index"
          class="flex gap-4 items-start"
          :class="[
            index < visibleCharacteristics.length - 1 && 'border-b border-gray-200',
            index === 0 ? 'pb-1' : 'py-1',
          ]"
        >
          <span class="flex-1 min-w-0 font-medium text-gray-600">
            {{ characteristic.characteristic.name }}
          </span>
          <span class="shrink-0 font-semibold text-gray-900 text-right">
            {{ getCharacteristicValue(characteristic) }}
          </span>
        </div>
      </div>
      <button
        v-if="characteristics.length > 4"
        class="text-xs text-blue-500 underline"
        @click="isShortCharacteristics = !isShortCharacteristics"
      >
        {{ isShortCharacteristics ? 'Показать все' : 'Свернуть' }}
      </button>
    </div>
    <div
      v-if="equipments?.length"
      class="flex flex-col gap-2"
    >
      <h2 class="font-bold text-lg leading-7 text-gray-900">Комплектация</h2>
      <div class="flex flex-col text-sm leading-6">
        <div
          v-for="(equipment, index) in visibleEquipments"
          :key="index"
          class="flex gap-4 items-start"
          :class="[
            index < visibleEquipments.length - 1 && 'border-b border-gray-200',
            index === 0 ? 'pb-1' : 'py-1',
          ]"
        >
          <span class="flex-1 min-w-0 font-medium text-gray-600">
            {{ equipment.name }}
          </span>
          <span class="shrink-0 font-semibold text-gray-900 text-right whitespace-nowrap">
            {{ equipment.count }} шт.
          </span>
        </div>
      </div>
      <button
        v-if="equipments.length > 4"
        class="text-xs text-blue-500 underline"
        @click="isShortEquipments = !isShortEquipments"
      >
        {{ isShortEquipments ? 'Показать все' : 'Свернуть' }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useLot } from '~/composables/useLot'

const props = defineProps({
  lotId: {
    type: [String, Number],
    required: true,
  },
})

const { lot } = useLot(props.lotId)

const description = computed(() => lot.value.description)
const equipments = computed(() => lot.value.equipments)
const characteristics = computed(() => lot.value.characteristicAssignments)

const isShortEquipments = ref(true)
const isShortCharacteristics = ref(true)

const visibleCharacteristics = computed(() => {
  if (!characteristics.value?.length) return []
  return isShortCharacteristics.value
    ? characteristics.value.slice(0, 4)
    : characteristics.value
})

const visibleEquipments = computed(() => {
  if (!equipments.value?.length) return []
  return isShortEquipments.value
    ? equipments.value.slice(0, 4)
    : equipments.value
})

function getCharacteristicValue (characteristic) {
  if (characteristic.characteristic.kind === 'RANGE') {
    const unit = characteristic.characteristic.extra?.unitOfMeasurement
    return `${characteristic.extra.value}${unit ? ` ${unit}` : ''}`
  }
  return characteristic.extra.items.map(item => item.name).join(', ')
}
</script>
